import cn from 'clsx'
import { LeftBarButton } from '@/components/LeftBarButton/LeftBarButton'
import type { LeftBarButtonProps } from '@/components/LeftBarButton/LeftBarButton'

import css from './ChoiceButton.module.css'

export interface ChoiceButtonProps extends LeftBarButtonProps {
    children: React.ReactNode
    className?: string
}

export function ChoiceButton({ children, className, ...rest }: ChoiceButtonProps) {
    return (
        <LeftBarButton className={cn(css.choiceBtn, className)} {...rest}>
            {children}
        </LeftBarButton>
    )
}
